import React from 'react';


export default class PointerData extends React.Component {
  render() {

    const Row = (props) => (
      <tr>
        <th>{props.title}</th>
        <td>{props.value}</td>
      </tr>
    );

    return (
      <div>
        <table>
            <tbody>
              <Row title="Red %" value={this.props.redPercentage} />
              <Row title="Red threshold" value={this.props.redTreshold} />
              <Row title="Vector Distances" value={this.props.vectorDistances} />
              <Row title="Pointer sizes" value={this.props.edgePoints} />
            </tbody>
        </table>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./client/components/PointerData.js